<div class="ion-page modal-body">
  <div class="modalInnerWrapper modal-content">
    <div class="modal-body">
      <h4 class="t-h4 mt-4 t-medium">{{'COMMON.LIVE-STREEM' | translate}}</h4>

      <!-- Video.js container with aspect ratio wrapper -->
      <div class="video-container">
        <video id="video-player" class="video-js vjs-default-skin" oncontextmenu="return false" controls poster="../../../../assets/images/Video_banner.jpg" autobuffer="true">
          <source [src]="selected_video" [type]="getVideoType(selected_video)">
        </video>
      </div>

      <!-- Switch for video type -->
      <ion-item lines="none">
        <ion-label style="font-size: small;text-align: right;" >{{'COMMON.HORSE-RACING' | translate}}</ion-label>
        <ion-toggle (ionChange)="toggle_switch($event)"></ion-toggle>
        <ion-label style="font-size: small;"  >{{'COMMON.GRAYHOUND-RACING' | translate}}</ion-label>
      </ion-item>
    </div>

    <!-- Close button -->
    <button (click)="dismiss()" type="link" class="close">
      <span class="icon icon-close"></span>
    </button>
  </div>
</div>
